


















































import {Component, Prop, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath, openDownloadDialog, sheet2blob} from "@/shared/services/helper/utils";
import {PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import XLSX from 'xlsx';
import PLTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentPrint/index.vue";
import PLTranshipmentExcel
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentExcel/index.vue";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import {Lading} from "@/interfaces/entity";
import PrintLading from "@/modules/ladings/Print/index.vue";
import LabelTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/LabelTranshipmentPrint/index.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "PLTranshipmentDetail",
    components: {LabelTranshipmentPrint, PrintLading, LadingPrintBill, PLTranshipmentExcel, PLTranshipmentPrint}
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible", {type: Boolean, default: false}) syncedVisible!: boolean;
    @Prop({type: Number, required: true}) readonly id!: number;
    @Prop({type: Boolean, required: false, default: false}) readonly isConfirmedTo!: boolean;

    printPickingListObj: Options = {
        id: 'print-picking-list-transhipment',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    printLabelObj: Options = {
        id: 'print-label-transhipment',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    get billLadingIds() {
        return this.getProp(this.pickingListTranshipment, 'billLadings', []).map((billLading: Lading) => billLading.rowGuid);
    }

    get pickingListTranshipment() {
        return PickingListTranshipmentStore.data[this.id];
    }

    closeModal() {
        this.syncedVisible = false;
    }

    printPickingList() {
        this.$print(this.printPickingListObj);
    }

    printLabel() {
        this.$print(this.printLabelObj);
    }

    exportExcel() {
        TableToExcel.convert(document.getElementById("table-excel-pl-transhipment"), {
            name: `Bảng kê chuyển vùng.xlsx`,
            sheet: {
                name: "Sheet 1"
            }
        });
    }
}
